module.exports = __webpack_public_path__ + "static/media/signature.43571be1.png";